import { render, staticRenderFns } from "./LotAddToWatchlist.vue?vue&type=template&id=444ab85c&scoped=true&"
import script from "./LotAddToWatchlist.vue?vue&type=script&lang=js&"
export * from "./LotAddToWatchlist.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "444ab85c",
  null
  
)

export default component.exports